import { createFileRoute } from '@tanstack/react-router'
import { Transactions } from '../screens/Transactions'
import { useAppState } from '../app-state'

function TransactionsRoute() {
  const { setDrawerTx, search, setSearch, railSelected, setRailSelected } = useAppState()

  return (
    <Transactions
      openDrawer={(tx) => setDrawerTx(tx)}
      search={search}
      setSearch={setSearch}
      accountFilter={railSelected === 'all' ? null : railSelected}
      setAccountFilter={(id) => setRailSelected(id ?? 'all')}
    />
  )
}

export const Route = createFileRoute('/transactions')({
  component: TransactionsRoute,
})
